module.exports = __webpack_public_path__ + "img/bgi3.adef058f.png";